
// Takes the cart items (array) from cart object and returns a shipping ETA string based on the "_availability_state" property of all cart items

const getCartShippingETA = (cartItems) => {

  // Opt out if no cart items
  if (cartItems.length < 1) return null



  // Set up variables
  let leapYear = false;
  let months = [
    { 'name' : 'January', 'days': 31 },
    { 'name' : 'February', 'days': 28 },
    { 'name' : 'March', 'days': 31 },
    { 'name' : 'April', 'days': 30 },
    { 'name' : 'May', 'days': 31 },
    { 'name' : 'June', 'days': 30 },
    { 'name' : 'July', 'days': 31 },
    { 'name' : 'August', 'days': 31 },
    { 'name' : 'September', 'days': 30 },
    { 'name' : 'October', 'days': 31 },
    { 'name' : 'November', 'days': 30 },
    { 'name' : 'December', 'days': 31 }
  ];
  if(leapYear == true) {
    months[1].days += 1;
  }
  let daysInYear = months.reduce((n, {days}) => n + days, 0); // Sum all 'days' properties in months array
  let now = new Date();
  let currentYear = now.getFullYear();
  let currentMonth = now.getMonth();
  let currentDate = now.getDate();

  // Get current day of year (e.g. 1st June = day 152)
  let currentDayOfYear = 0;
  months.forEach((month, i) => {
    if(i < currentMonth) {
      currentDayOfYear += month.days;
    }
  });
  currentDayOfYear += currentDate; // add days with month
  // Define month block terms
  let monthBlockTerms = ['early', 'mid', 'late'];




  // Function that takes number of days and returns shipping date array as [date, month, year]
  const getShippingDate = (shippingDays) => {

    // Get shipping day of year (e.g. 1st June = day 152)
    let shippingDayOfYear = currentDayOfYear + shippingDays;

    // Calculate shipping year based on shippingDayOfYear
    let additionalYears = Math.floor((shippingDayOfYear - 1) / daysInYear);
    let shippingYear = currentYear + additionalYears;

    // If shipping in following year, recalculate shipping day of year
    if(shippingDayOfYear > daysInYear) {
      if(shippingDayOfYear % daysInYear == 0) {
        shippingDayOfYear = daysInYear;
      } else {
        shippingDayOfYear = shippingDayOfYear % daysInYear;
      }
    }

    // Calculate shipping month and date based on shippingDayOfYear
    let shippingDate = 0;
    let shippingMonth = 0;
    let cumulativeDays = 0;
    for(let i = 0; i < months.length; i++) {
      if(shippingDayOfYear - (cumulativeDays + months[i].days) > 0) {
        cumulativeDays += months[i].days;
        shippingMonth += 1;
      } else {
        shippingDate = shippingDayOfYear - cumulativeDays;
        break;
      }
    }

    // Format shipping date
    // if(shippingDate.toString().length == 1) {
    //     shippingDate = '0'+shippingDate;
    // }
    var lastChar = shippingDate.toString().split('').pop();
    if(shippingDate > 10 && shippingDate < 20) { // all 'th' for teens
      shippingDate += 'th'
    } else if (lastChar == 1) {
      shippingDate += 'st'
    } else if (lastChar == 2) {
      shippingDate += 'nd'
    } else if (lastChar == 3) {
      shippingDate += 'rd'
    } else {
      shippingDate += 'th'
    }

    // Format shipping month
    shippingMonth = months[shippingMonth].name

    // Return full date as array so that start/end dates can be easily compared and formatted correctly
    return [shippingDate, shippingMonth, shippingYear];

  } // getShippingDate()




  // Function that takes month block (e.g. 'mid September') term and returns days range
  const monthBlockTermToDaysRange = (monthBlockTerm) => {

    // Get month and block separately
    let monthBlockMonth = monthBlockTerm.toLowerCase().replace('early', '').replace('mid', '').replace('late', '').trim();
    let monthBlockBlock = monthBlockTerm.toLowerCase().replace(monthBlockMonth, '').trim();
    // Get cumulative days up to month
    let cumulativeDays = 0;
    for(let i = 0; i < months.length; i++) {
      if(months[i].name.toLowerCase() == monthBlockMonth) {
        break;
      } else {
        cumulativeDays += months[i].days;
      }
    }
    // Calc daysRangeStart and daysRangeEnd based on month block
    let daysRangeStart = 0;
    let daysRangeEnd = 0;
    if(monthBlockBlock == 'early') { // Month block = 1st - 10th
      daysRangeStart = (cumulativeDays + 1) - currentDayOfYear;
      daysRangeEnd = (cumulativeDays + 10) - currentDayOfYear;
    } else if(monthBlockBlock == 'mid') { // Month block = 11th - 20th
      daysRangeStart = (cumulativeDays + 11) - currentDayOfYear;
      daysRangeEnd = (cumulativeDays + 20) - currentDayOfYear;
    } else if(monthBlockBlock == 'late') { // Month block = 21st - last day of month
      daysRangeStart = (cumulativeDays + 21) - currentDayOfYear;
      daysRangeEnd = (cumulativeDays + months.find((m) => m.name.toLowerCase() == monthBlockMonth).days) - currentDayOfYear;
    }
    // Make consideration for overlapping into new year
    if(daysRangeStart < 0) {
      daysRangeStart = daysInYear + daysRangeStart;
    }
    if(daysRangeEnd < 0) {
      daysRangeEnd = daysInYear + daysRangeEnd;
    }

    return `${daysRangeStart}-${daysRangeEnd}`;

  } // monthBlockTermToDaysRange()





  // Get array of cart item shipping times, each as object with 'defaultText', 'daysRangeStart' and 'daysRangeEnd'
  let cartItemShippingTimes = [];
  cartItems.forEach((item) => {
    // Exclude items with empty properties
    if(Object.keys(item.properties).length === 0) {
      return;
    }
    // Exclude add-on items
    if(item.properties.hasOwnProperty('Added to')) {
      return;
    }
    let shippingTime = item.properties['_availability_state'];
    // Exclude items that don't have shipping time
    if(!shippingTime) {
      return;
    // Exclude items that don't include "Ships in..."
    } else if(!shippingTime.toLowerCase().includes('ships in')) {
      return;
    } else {
      // Get default shipping time text
      let defaultText = shippingTime.replace('Ships in', '').replace('ships in', '').trim();
      // Get start and end shipping time in days
      // If shipping time has no range, assign 'daysRangeStart' and 'daysRangeEnd' with shipping days value
      let daysRangeStart = 0;
      let daysRangeEnd = 0;
      // Shipping time defined in days
      if(defaultText.toLowerCase().includes('day')) {
        let days = defaultText.toLowerCase().replace('days', '').replace('day', '').trim();
        if(days.includes ('-')) {
          daysRangeStart = parseInt(days.split('-')[0].trim());
          daysRangeEnd = parseInt(days.split('-')[1].trim());
        } else {
          daysRangeStart = daysRangeEnd = parseInt(days);
        }
      }
      // Shipping time defined in weeks
      else if(defaultText.toLowerCase().includes('week')) {
        let weeks = defaultText.toLowerCase().replace('weeks', '').replace('week', '').trim();
        if(weeks.includes ('-')) {
          daysRangeStart = parseInt(weeks.split('-')[0].trim()*7);
          daysRangeEnd = parseInt(weeks.split('-')[1].trim()*7);
        } else {
          daysRangeStart = daysRangeEnd = parseInt(weeks*7);
        }
      }
      // Shipping time defined as month block term
      else {
        if(monthBlockTerms.some(term => defaultText.toLowerCase().includes(term))) {
          // Convert month block term to days range
          let monthBlockDaysRange = monthBlockTermToDaysRange(defaultText);
          daysRangeStart = parseInt(monthBlockDaysRange.split('-')[0]);
          daysRangeEnd = parseInt(monthBlockDaysRange.split('-')[1]);
        }
      }
      // Push shipping time as object
      cartItemShippingTimes.push(
        {
          'defaultText' : defaultText,
          'daysRangeStart' : daysRangeStart,
          'daysRangeEnd' : daysRangeEnd
        }
      );
    }
  });
  // console.log(cartItemShippingTimes);
  if (cartItemShippingTimes.length < 1) return null // Opt out if no shipping times



  // Get longest shipping time (based on range end)
  let longestDaysRangeEnd = 0;
  cartItemShippingTimes.forEach((item) => {
    if(item.daysRangeEnd > longestDaysRangeEnd) {
      longestDaysRangeEnd = item.daysRangeEnd
    }
  });
  let longestShippingItem = cartItemShippingTimes.find(item => item.daysRangeEnd == longestDaysRangeEnd);
  // console.log(`Longest shipping time is: ${longestShippingItem.defaultText}`);



  // If longest shipping time is month block term, return this
  if(monthBlockTerms.some(term => longestShippingItem.defaultText.includes(term))) {
    return longestShippingItem.defaultText;
  }



  // Create final shipping date
  let finalShippingDate = '';
  // Check for date range
  if(longestShippingItem.daysRangeStart == longestShippingItem.daysRangeEnd) {
    // No date range
    let shippingDateArray = getShippingDate(longestShippingItem.daysRangeEnd);
    finalShippingDate =
      shippingDateArray[0]
      + ' ' + shippingDateArray[1]
      //+ ' ' + shippingDateArray[2]
    ;
  }
  else {
    // Date range
    let startShippingDateArray = getShippingDate(longestShippingItem.daysRangeStart);
    let endShippingDateArray = getShippingDate(longestShippingItem.daysRangeEnd);
    if(startShippingDateArray[1] == endShippingDateArray[1]) {
      // Date range within same month
      finalShippingDate =
        startShippingDateArray[0]
        + ' - ' + endShippingDateArray[0]
        + ' ' + startShippingDateArray[1]
        //+ ' ' + endShippingDateArray[2]
      ;
    }
    else {
      // Date range spans different months
      finalShippingDate =
        startShippingDateArray[0]
        + ' ' +  startShippingDateArray[1]
        + ' - ' + endShippingDateArray[0]
        + ' ' + endShippingDateArray[1]
        //+ ' ' + endShippingDateArray[2]
      ;
    }
  }
  // console.log(`Estimated Shipping: ${finalShippingDate}`);

  // Return full formatted Estimated Shipping date
  return finalShippingDate;


} // getCartShippingETA()
